import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TopLogo from "../../components/layout/TopLogo";
import { useLiff } from "react-liff";
import { SearchId } from "../../services/SearchId";
import dayjs from "dayjs";
import plus from "../../assets/images/icon/icon-plus.svg";
import editIcon from "../../assets/images/icon/edit-circle.svg";
import calendarIcon from "../../assets/images/icon/calendar-gray.svg";
import calendarWhiteIcon from "../../assets/images/icon/calendar-white.svg";
import clockIcon from "../../assets/images/icon/clock-gray.svg";
import locationIcon from "../../assets/images/icon/location-gray.svg";
import bellIcon from "../../assets/images/icon/bell.svg";
import bellGreenIcon from "../../assets/images/icon/bell-green.svg";
import SuccessStyle from "../../assets/images/success-style.png";
import dogImage from "../../assets/images/icon/icon-dog.svg";
import catImage from "../../assets/images/icon/icon-cat.svg";
import { getPetNotification } from "../../services/Dogbook";
import dogHeart from "../../assets/images/dogbook/dog-heart-p2.png";
import dogFace from "../../assets/images/icon/dogFace.svg";
import catFace from "../../assets/images/icon/catFace.svg";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function NotificationMain() {
    const navigate = useNavigate();
    const { liff } = useLiff();
    const lineId = liff.getDecodedIDToken().sub;

    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1); // เดือนปัจจุบัน
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [memberId, setMemberId] = useState(null);
    // กำหนด MIN_DATE เป็นเดือน 1 ของปีปัจจุบัน และ MAX_DATE เป็นเดือน 12 ของปีปัจจุบัน
    const currentDate = new Date();
    const MIN_DATE = `${currentDate.getFullYear()}-01`;
    const MAX_DATE = `${currentDate.getFullYear()}-12`;

    useEffect(() => {
        getSearchId();
    }, []);

    useEffect(() => {
        if (memberId) {
            getNotifications(memberId);
        }
    }, [currentMonth]);

    useEffect(() => {
       console.log(notifications);
    }, [notifications]);


    async function getSearchId() {
        try {
            const response = await SearchId({
                params: { lineId: lineId || null },
            });

            if (!response.data.body.memberId) {
                window.location.replace("/register");
            } else {
                setMemberId(response.data.body.memberId);
                getNotifications(response.data.body.memberId);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function getNotifications(memberId) {
        try {
            const response = await getPetNotification({
                memberId: memberId,
                params: { month: currentMonth, year: currentYear, status: 4 },
            });
            var data = response.data.resultData;
            data.forEach(element => {
                if (element.reminder === 1) {
                    element.nextReminder = dayjs(element.notifyDate).add(1, 'month').format('DD/MM/YYYY');
                }
                if (element.reminder === 2) {
                    element.nextReminder = dayjs(element.notifyDate).add(3, 'month').format('DD/MM/YYYY');
                }
                if (element.reminder === 3) {
                    element.nextReminder = dayjs(element.notifyDate).add(6, 'month').format('DD/MM/YYYY');
                }
                if (element.reminder === 4) {
                    element.nextReminder = dayjs(element.notifyDate).add(1, 'year').format('DD/MM/YYYY');
                }
                element.notifyDateFormatted = dayjs(element.notifyDate).format('DD/MM/YYYY');
                element.notifyTimeFormatted = element.notifyTime.slice(0, 5);
                element.nextNotifyDateFormatted = element.nextNotifyDate ? dayjs(element.nextNotifyDate).format('DD/MM/YYYY') : null;
            });
            console.log(data);
            setNotifications(data);
            
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    const handleEditNotification = (notification) => {
        navigate("/dogbook-edit-noti", { state: { notification: notification } });
    };

    // ชื่อเดือนภาษาไทย
    const thaiMonths = [
        'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
    ];

    if (loading) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <div>กำลังโหลด...</div>
            </div>
        );
    }

    return (
        <div id="notification-page" className="mb-[80px]">
            <div className="gradientBgBlue min-h-[calc(100vh-60px)]]">
                <div className="mb-[10px] mt-[-12]">
                    <p className="text-white text-[28px] font-medium">ตารางนัดหมาย</p>
                </div>
                <div className="relative flex flex-col justify-between bg-white pt-[10px] pb-[14px] px-[17px] rounded-[4px]"
                    style={{ zIndex: '20' }}
                >
                    <div className="flex justify-center mt-[6px]">
                        <div className="relative">
                            <input
                                type="month"
                                value={`${currentYear}-${currentMonth.toString().padStart(2, '0')}`}
                                onChange={(e) => {
                                    const [year, month] = e.target.value.split('-').map(Number);
                                    setCurrentMonth(month);
                                    setCurrentYear(year);

                                    console.log(`Selected: ${thaiMonths[month - 1]} ${year}`);
                                }}
                                min={MIN_DATE}
                                max={MAX_DATE}
                                className="appearance-none bg-lightBlue text-white px-[40px] py-[6px] rounded-[25px] text-[24px] cursor-pointer outline-none border-none opacity-0 w-[250px]"
                            />
                            <div className="absolute inset-0 bg-lightBlue text-white pl-[9px] py-[6px] rounded-[25px] flex items-center justify-center gap-[8px] pointer-events-none">
                                <img src={calendarWhiteIcon} alt="calendar" className="w-[20px] h-[20px]" />
                                <span className="text-[24px]">{thaiMonths[currentMonth - 1]} {currentYear}</span>
                                <KeyboardArrowDownIcon />
                            </div>
                        </div>
                    </div>
                    <hr className="border-b-1px border-lightGray w-full my-[15px]" />

                    {/* Notifications List */}
                    <div className="flex-1 space-y-[16px]">
                        {notifications.length === 0 ?
                            <div className="flex justify-center items-center h-full">
                                <p className="text-[20px] text-gray-500">ไม่พบตารางนัดหมาย</p>
                            </div>
                            :
                            <>
                                {notifications.map((notification, index) => (
                                    <div
                                        key={notification.id}
                                        className="border rounded-[12px] p-[16px] relative"
                                        style={{ backgroundColor: notification.pet.species === 1 ? '#EAF1FC' : '#EAF6EF', borderColor: notification.pet.species === 1 ? '#0A4197' : '#00693E' }}
                                    >
                                        <button
                                            onClick={() => handleEditNotification(notification)}
                                            className="absolute top-[5px] right-[5px] p-[8px]"
                                        >
                                            <img src={editIcon} alt="edit" className="w-[25px] h-[25px]" />
                                        </button>

                                        {/* Pet Info */}
                                        <div className="flex gap-[12px]">
                                            <div className={`w-[40px] h-[40px] rounded-full bg-gray-200 flex justify-center items-center relative`}>
                                                {notification.pet.species === 1 ? (
                                                    notification.pet.picture ?
                                                        <img className="absolute left-0 right-0 mx-auto rounded-full w-[40px] h-[40px] object-cover border border-blue" src={notification.pet.picture} alt="dog" /> :
                                                        <div className={`w-[40px] h-[40px] rounded-full border border-blue flex justify-center items-center`}>
                                                            <img src={dogFace} alt="dog" className="h-[25px] w-[25px] object-center" />
                                                        </div>
                                                ) : (
                                                    notification.pet.picture ?
                                                        <img className="absolute left-0 right-0 mx-auto rounded-full w-[40px] h-[40px] object-cover border border-green" src={notification.pet.picture} alt="cat" /> :
                                                        <div className={`w-[40px] h-[40px] rounded-full border border-green flex justify-center items-center`}>
                                                            <img src={catFace} alt="cat" className="h-[25px] w-[25px] object-center" />
                                                        </div>
                                                )}
                                            </div>
                                            <div style={{ maxWidth: '220px' }}>
                                                <div className="flex items-center gap-[8px]">
                                                    <div className={`inline-flex`}>
                                                        <img src={notification.pet.species === 1 ? dogImage : catImage} alt="dog" className="h-[20px] mr-[5px]" />
                                                        <p className={`text-[22px] mt-[-2px] font-bold ${notification.pet.species === 1 ? 'text-blue' : 'text-green'}`}>{notification.pet.name}</p>
                                                    </div>

                                                </div>
                                                <div >
                                                    {notification.activity1 && (<p className="text-[16px]">• {notification.activity1.name}</p>)}
                                                    {notification.activity2 && (<p className="text-[16px]">• {notification.activity2.name}</p>)}
                                                </div>
                                                {/* Last Activity */}
                                                {notification.note && (
                                                    <div className="">
                                                        <p className="text-[14px] text-gray mb-[4px]">รายละเอียดเพิ่มเติม</p>
                                                        <p className="text-[16px] text-gray-800">{notification.note}</p>
                                                    </div>
                                                )}

                                                {/* Appointment Details */}
                                                <div>
                                                    <div className="flex items-center gap-[8px]">
                                                        <img src={calendarIcon} alt="calendar" className="w-[16px] h-[16px] text-gray-500" />
                                                        <span className="text-[16px] text-gray-700">{notification.notifyDateFormatted}</span>
                                                        <img src={clockIcon} alt="clock" className="w-[16px] h-[16px] text-gray-500 ml-[16px]" />
                                                        <span className="text-[16px] text-gray-700">{notification.notifyTimeFormatted}</span>
                                                    </div>

                                                    <div className="flex gap-[8px]">
                                                        <img src={locationIcon} alt="location" className="w-[16px] h-[16px] text-gray-500 mt-[3px]" />
                                                        <span className="text-[16px] text-gray-700">{notification.otherClinic ? notification.otherClinic : notification.clinic.name}</span>
                                                    </div>
                                                </div>

                                                {/* Next Notification */}
                                                {notification.nextNotifyDate && (
                                                    <div>
                                                        <div className="flex items-center gap-[8px]">
                                                            <span className="text-[14px] text-gray">นัดหมายครั้งต่อไป</span>
                                                        </div>
                                                        <div className="flex items-center gap-[8px] mt-[-4px]">
                                                            <img src={notification.pet.species === 1 ? bellIcon : bellGreenIcon} alt="bell" className="w-[16px] h-[16px] text-green-600" />
                                                            <span className="text-[16px] text-gray-800">{notification.nextNotifyDateFormatted}</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>


                                    </div>
                                ))}
                            </>
                        }
                    </div>

                    <div className="mt-[14px]">
                        <img src={dogHeart} alt="dog-heart" className="h-[100px]" />
                    </div>
                </div>
                <img
                    src={SuccessStyle}
                    alt="logo"
                    style={{
                        width: "60%", right: '20px',
                        top: '20px', zIndex: '10'
                    }}
                    className="mt-[-20px] mr-[-20px] absolute"
                />
                {/* <div className="absolute flex flex-col justify-between bg-white py-[24px] px-[17px] rounded-[4px] min-h-[calc(100vh-123px)]"
                    style={{ zIndex: '20' }}>
                </div> */}

            </div>
            <div
                id="add-btn"
                className="fixed bottom-0 left-0 right-0 flex flex-col justify-center bg-white px-[20px] pt-[16px] pb-[24px] z-30"
            >
                <button
                    onClick={() => navigate("/dogbook-add-noti")}
                    className="flex justify-center items-center bg-blue rounded-[28px] w-full gap-[10px] py-[8px]"
                >
                    <img src={plus} alt="plus" className="w-[20px] h-[20px]" />
                    <p className="text-[24px] text-white text-center">
                        สร้างตารางนัดหมาย
                    </p>
                </button>
            </div>
        </div>
    );
}
